module.exports = __webpack_public_path__ + "img/粉绿CP恐龙公仔.4653a8fc.jpg";